module.exports = __webpack_public_path__ + "img/warning.b2294fb9.svg";